import styled from 'styled-components';
import { scrollBar } from '../../style/helpers';

export const Content = styled.div`
  position: relative;
  padding: 20px;
  height: calc(100vh - 72px);
  ${scrollBar}
`;
